// extracted by mini-css-extract-plugin
export var searchHeader = "_7f-0";
export var searchHeaderDark = "_7f-1";